export const getId = ({ id }) => id;
